/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PublicIcon from '@material-ui/icons/Public';
import { makeStyles } from '@material-ui/styles';
import List from '@material-ui/core/List';
import  ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import styles from '../../utils/navigationStyle';



import { staticMenu } from '../../helpers/NavigatorList';


const useStyles = makeStyles(theme => ({
  ...styles
}))

const StaticList = props => {
  const { data, className, ...rest } = props;

  const classes = useStyles();

  return (
    
          <React.Fragment >
            
            <ListItem className={classes.categoryHeader}>
              <ListItemText
                classes={{
                  primary: classes.categoryHeaderPrimary,
                }}
              >
                See Also
              </ListItemText>
            </ListItem>

            {staticMenu.children.map(({ id: childId, icon, active, link }) => (
             <RouterLink activeClassName={classes.itemActiveItem} to={`/${link}`} >
              <ListItem
                key={childId}
                button
                className={clsx(classes.item, active && classes.itemActiveItem)}
              >
                <ListItemIcon className={classes.itemIcon}>{icon}</ListItemIcon>
                <ListItemText
                  classes={{
                    primary: classes.itemPrimary,
                  }}
                >
                  {childId}
                </ListItemText>
              </ListItem>
              </RouterLink>
            ))}

            <Divider className={classes.divider} />
          </React.Fragment>
      
  )    
};

StaticList.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired
};

export default StaticList;
